import { render, staticRenderFns } from "./UsersPrivilegeReservationsSchedules.vue?vue&type=template&id=5393bb9b&scoped=true&"
import script from "./UsersPrivilegeReservationsSchedules.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeReservationsSchedules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5393bb9b",
  null
  
)

export default component.exports